export default __webpack_public_path__ + "static/chandrasekar-86e179a606a7b87f2b5cc16cde3542d7.jpg";